module.exports = __webpack_public_path__ + "media/images/explorer-a19168c8a3a232567560b38af809caa3.svg";